import { IndustrialProcessSchema } from "./PrismaZod";

export const IndustrialProcess = IndustrialProcessSchema.enum;
